import React from 'react';
import cn from 'classnames';

import logo from '../../assets/logo.png';

import styles from './Logo.module.scss';

function Logo({className, ...restProps}: React.HTMLAttributes<HTMLDivElement>) {
  const imageStyle = restProps.style;
  return (
    <div className={cn(styles.root, className)} {...restProps}>
      <img
        style={{
          width: imageStyle?.width || 180,
          height: imageStyle?.height || 180,
        }}
        alt="logo"
        src={logo}
      />
    </div>
  );
}

export default Logo;
